module.exports = __webpack_public_path__ + "static/img/gl-7.f4e61ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-7.jpg
// module id = /nHj
// module chunks = 0